// src/utils/request.js
import axios from 'axios';
import { getCurrentLang } from '@/utils/lang'; // ⭐ 新增

// 创建 axios 实例
const service = axios.create({
    baseURL: 'https://dap.webbch.com/api', 
  // baseURL: 'api/', // 你的后端网关
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 如果有 token 就带上
    const token = localStorage.getItem('access_token');
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    const lang = getCurrentLang();
    config.headers['Accept-Language'] = lang;
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error('API Error:', error);
    const msg =
      error.response?.data?.msg ||
      error.message ||
      'Network error, please try again.';
    return Promise.reject(new Error(msg));
  }
);

export default service;
